// src/components/TeamMember.tsx
import React from 'react';

interface TeamMemberProps {
  imagePath: string;
  name: string;
  position: string;
  className?: string; // Add this line
}

const TeamMember: React.FC<TeamMemberProps> = ({ imagePath, name, position, className }) => {
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <div className={`flex flex-col items-center text-center max-w-72 mx-auto group ${className || ''}`}>
      <div className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56 rounded-full overflow-hidden mb-4 lg:mb-6 border-2 border-mystic-violet transition-transform duration-300 group-hover:scale-110">
        <img
          src={imagePath}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
            const target = e.currentTarget as HTMLImageElement;
            target.src = `https://placehold.co/224x224/13141F/FFFFFF?text=${getInitials(name)}`;
          }}
        />
      </div>
      <h3 className="text-lg sm:text-xl font-bold text-white mb-2 transition-transform duration-300 group-hover:scale-110">{name}</h3>
      <p className="text-base text-white/80 transition-transform duration-300 group-hover:scale-110">{position}</p>
    </div>
  );
};

export default TeamMember;
